import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import Tooltip from '@material-ui/core/Tooltip';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PersonIcon from '@material-ui/icons/Person';
import PlaceIcon from '@material-ui/icons/Place';
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import Time from "react-time-format";
import {Redirect} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
    },
    iconBadge: {
        width: 38,
        height: 38,
        borderRadius: 10,
        background: 'rgba(44, 71, 103, 0.08)',
        color: '#2c4767',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginRight: theme.spacing(1.5),
    },
    title: {
        fontSize: '1.05rem',
        fontWeight: 700,
        color: '#1a2733',
        margin: 0,
        lineHeight: 1.3,
    },
    empty: {
        flex: 1,
        marginTop: theme.spacing(2),
        padding: theme.spacing(3),
        textAlign: 'center',
        background: 'rgba(247, 244, 238, 0.6)',
        borderRadius: 10,
        border: '1px dashed rgba(176, 141, 87, 0.35)',
    },
    emptyText: {
        color: '#5a6675',
        fontSize: '0.95rem',
        margin: 0,
    },
    tableWrap: {
        marginTop: theme.spacing(1),
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        marginLeft: -theme.spacing(1),
        marginRight: -theme.spacing(1),
    },
    table: {
        '& thead th': {
            color: '#5a6675',
            fontWeight: 600,
            fontSize: '0.75rem',
            letterSpacing: 1,
            textTransform: 'uppercase',
            borderBottom: '1px solid rgba(44, 71, 103, 0.12)',
            padding: theme.spacing(1, 1.5),
        },
        '& tbody td': {
            fontSize: '0.92rem',
            color: '#1a2733',
            borderBottom: '1px solid rgba(44, 71, 103, 0.06)',
            padding: theme.spacing(1.25, 1.5),
        },
    },
    headerIcon: {
        color: '#b08d57',
        verticalAlign: 'middle',
    },
    row: {
        cursor: 'pointer',
        transition: 'background-color 120ms ease',
        '&:hover, &:focus': {
            backgroundColor: 'rgba(176, 141, 87, 0.08)',
        },
        '&:last-child td': {
            borderBottom: 'none',
        },
    },
    deceasedCell: {
        fontWeight: 600,
    },
    urnIcon: {
        marginRight: theme.spacing(0.75),
    },
}));

export default function Upcomming(props) {
    const classes = useStyles();
    const [funeralDetail, setFuneralDetail] = useState(null);

    const handleClick = (id) => {
        setFuneralDetail(id);
    }

    const Icon = props.icon;

    return (
        <React.Fragment>
            <div className={classes.header}>
                {Icon && (
                    <div className={classes.iconBadge}>
                        <Icon fontSize="small"/>
                    </div>
                )}
                <Typography component="h2" className={classes.title}>
                    {props.title}
                </Typography>
            </div>
            {props.data.length === 0 ? (
                <div className={classes.empty}>
                    <Typography className={classes.emptyText}>Žiadne udalosti.</Typography>
                </div>
            ) : (
                <div className={classes.tableWrap}>
                    <Table size="small" className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">
                                    <Tooltip title="Zosnulý"><PersonIcon fontSize="small" className={classes.headerIcon}/></Tooltip>
                                </TableCell>
                                <TableCell align="left">
                                    <Tooltip title="Čas"><AccessTimeIcon fontSize="small" className={classes.headerIcon}/></Tooltip>
                                </TableCell>
                                <TableCell align="left">
                                    <Tooltip title="Miesto"><PlaceIcon fontSize="small" className={classes.headerIcon}/></Tooltip>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.data.map((row) => (
                                <TableRow className={clsx(classes.row)} key={row.event_id || row.funeral_id} onClick={() => {
                                    handleClick(row.funeral_id)
                                }}>
                                    <TableCell className={classes.deceasedCell}>
                                        {row.type === 'urn_funeral' && (
                                            <Tooltip title="Pohreb urny">
                                                <span className={classes.urnIcon} role="img" aria-label="Pohreb urny">⚱️</span>
                                            </Tooltip>
                                        )}
                                        {row.deceased}
                                    </TableCell>
                                    <TableCell><Time value={row.date} format="DD.MM.YYYY HH:mm"/></TableCell>
                                    <TableCell>{row.place}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            )}
            {funeralDetail ? <Redirect to={{
                pathname: `/pohreb/${funeralDetail}/info`,
                state: {from: props.location}
            }}/> : <></>}
        </React.Fragment>
    );
}
